export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./src/axis";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-axis/index.js
// module id = p25H
// module chunks = 0